import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { StateService } from '@uirouter/angular';
import moment from 'moment';
import { combineLatest, ReplaySubject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as fromShared from '../../shared';
import { Process } from '../../shared';
import {
    FilterService,
    SelectItem,
    Table
} from '../../shared/efaact-primeng.module';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromStore from '../store';

@Component({
    selector: 'ef-checkup-presenter',
    templateUrl: './checkup-presenter.component.html',
    styleUrls: ['./checkup-presenter.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckupPresenterComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    processSelectItem: SelectItem[];
    nameSelectItem: SelectItem[];
    @ViewChild('dtCheckup') checkupTable: Table;
    dateFilters: any;
    private CheckupsSubject = new ReplaySubject<Array<fromStore.Checkup>>(1);
    private _checkups: Array<fromStore.Checkup>;
    dropdownItemHeight = environment.dropdownItemHeight;
    @Input() public set checkups(value: Array<fromStore.Checkup>) {
        this._checkups = value;
        this.CheckupsSubject.next(this._checkups);
        if (value) {
            // value = value.map(x => ({
            //     ...x,
            //     MsgDate: new Date(x.MsgDate)
            // }));
            this.processSelectItem = fromShared
                .uniqBy(value, x => x.MsgProcessID)
                .map(x => ({
                    label: x.ProcessTitle,
                    value: x.MsgProcessID
                }));
            this.nameSelectItem = fromShared
                .uniqBy(value, x => x.MsgEntityID)
                .map(x => ({
                    label: x.MsgEntity,
                    value: x.MsgEntityID
                }));
        }

    }
    public get checkups(): Array<fromStore.Checkup> {
        return this._checkups;
    }
    private _processes: Array<Process>;
    private ProcessesSubject = new ReplaySubject<Array<Process>>(1);
    @Input() public set processes(value: Array<Process>) {
        this._processes = value;
        this.ProcessesSubject.next(this._processes);
    }
    public get processes(): Array<Process> {
        return this._processes;
    }
    public processItems: SelectItem[];
    public entityNames: SelectItem[];
    public get categoryItems(): SelectItem[] {
        return fromShared
            .uniqBy(this._checkups, x => x.CatDescription)
            .map(x => ({
                label: x.CatDescription,
                value: x.CatDescription
            }));
    }
    private active = true;
    cols = [
        { field: 'CatDescription', header: 'Category' },
        { field: 'ProcessTitle', header: 'Process' },
        { field: 'MsgDate', header: 'Date' },
        { field: 'MsgEntity', header: 'Name' },
        { field: 'MsgText', header: 'Message' },
        { field: 'MsgAction', header: 'Action' }
    ];
    constructor(
        public ss: StateService,
        private log: LoggingService,
        private filterService: FilterService
    ) {}
    ngOnInit() {
        this.setupSubscriptions();
    }
    ngAfterViewInit() {
        this.addDateRangeFilter();
    }
    ngOnDestroy() {
        this.active = false;
    }
    setupSubscriptions() {
        combineLatest([this.CheckupsSubject, this.ProcessesSubject])
            .pipe(takeWhile(() => this.active))
            .subscribe(([checkups, processes]) => {
                this.processItems = fromShared
                    .uniqBy(
                        checkups.map(x => ({
                            value: processes.find(
                                p => p.ProcessID === x.MsgProcessID
                            )
                                ? processes.find(
                                      p => p.ProcessID === x.MsgProcessID
                                  ).ProcessID
                                : 0,
                            label: x.ProcessTitle
                        })),
                        x => x.value
                    )
                    .sort((a, b) =>
                        a.label
                            .toLocaleLowerCase()
                            .localeCompare(b.label.toLocaleLowerCase())
                    );
                this.entityNames = fromShared
                    .uniqBy(
                        checkups.map(x => ({
                            value: x.MsgEntity,
                            label: x.MsgEntity
                        })),
                        x => x.value
                    )
                    .sort((a, b) =>
                        a.label
                            .toLocaleLowerCase()
                            .localeCompare(b.label.toLocaleLowerCase())
                    );
                this.log.verbose({
                    type: 'CheckupPresenterComponent:processItems',
                    checkups,
                    processes,
                    processItems: this.processItems
                });
            });
    }

    addDateRangeFilter() {
        this.filterService.register(
            'dateRangeFilter',
            (value, filter): boolean => {
                this.log.verbose({
                    type: 'CheckupPresenterComponent:addDateRangeFilter',
                    value,
                    filter
                });
                if (value === undefined || value === null) {
                    return false;
                }
                return moment(value).isBetween(
                    moment(this.dateFilters[0]),
                    moment(this.dateFilters[1])
                );
                // get the from/start value
            }
        );
    }
    filterDate(event) {
        this.checkupTable.filter(
            moment(event).format('MM/DD/YYYY'),
            'MsgDate',
            'contains'
        );
    }

    clearAllFilters() {
        this.checkupTable.clear();
        this.dateFilters = null;
    }
}
